import "../css/banner.css";
import "../css/about.css";
import "../css/menu.css";
import "../css/links.css";
import "../css/footer.css";
import "../css/featured_nft.css";

import React, { useState, useEffect } from "react";

const menuButtonWhite = require("../assets/menu-button-white.png");
const menuButtonBlack = require("../assets/menu-button-black.png");
// const openseaLogo = require("../assets/opensea.png");

function Menu(props) {
  const { schema, theme } = props;
  return (
    <div
      className="menu"
      onClick={() => {
        alert("Create your own page: coming soon!");
      }}
    >
      {theme["menu-button"] === "black" ? (
        <img src={menuButtonBlack} alt="menu" />
      ) : (
        <img src={menuButtonWhite} alt="menu" />
      )}
    </div>
  );
}

function Banner(props) {
  const { schema, theme } = props;
  return (
    <div className="banner">
      <div className="left">
        <img src={schema.primary_pfp} alt="primary-pfp" />
        <h1>{schema.username}</h1>
      </div>
      <div className="right">
        <div className="pfps">
          {schema.featured_pfps.map((pfp, index) => {
            return <img key={index} src={pfp} alt="pfp" />;
          })}
        </div>
      </div>
    </div>
  );
}

function Links(props) {
  const { schema, theme } = props;
  return schema.links ? (
    <div
      className="links"
      style={{ backgroundColor: schema.accent, borderColor: theme.color }}
    >
      {Object.entries(schema.links).map(([name, link]) => {
        return (
          <div
            className="container"
            style={{
              backgroundColor: schema.accent,
              borderColor: theme.color,
            }}
          >
            <a key={name} href={link} target="_blank" rel="noreferrer">
              {name}
            </a>
          </div>
        );
      })}
    </div>
  ) : null;
}

function About(props) {
  const { schema, theme } = props;
  return (
    <div className="about">
      <div className="bio">
        <h2>Bio</h2>
        <div>{schema.bio}</div>
      </div>
      <div className="status">
        <h2>Status</h2>
        <div>{schema.status}</div>
      </div>
    </div>
  );
}

function FeaturedNFT(props) {
  const { schema, theme } = props;
  let [openseaUrl, setOpenseaUrl] = useState(null);

  useEffect(() => {
    // Get the image url
    const contractAddress = schema.featured_nft.contract_address;
    const tokenId = schema.featured_nft.token_id;
    setOpenseaUrl(`https://opensea.io/assets/${contractAddress}/${tokenId}`);
  }, [schema.featured_nft]);

  return (
    <div className="featured-nft">
      <div className="container">
        <h2>Featured NFT</h2>
        {/* <div>VIEW GALLERY</div> */}
        <a className="nft" href={openseaUrl} target="_blank" rel="noreferrer">
          <img
            className="main"
            src={schema.featured_nft.url}
            alt="featured-nft"
          />
          <div className="name">{schema.featured_nft.name}</div>
        </a>
      </div>
    </div>
  );
}

function Footer(props) {
  const { schema, theme } = props;
  return (
    <div
      className="footer"
      style={{ borderColor: theme.color, backgroundColor: theme.secondary }}
    >
      <div>This page is hosted decentrally on IPFS</div>
      <div>{/* Follow us on <a href="https://twitter.com">Twitter</a> */}</div>
    </div>
  );
}

function Home(props) {
  const { schema, theme } = props;
  return (schema !== null) & (theme !== null) ? (
    <div
      className="home"
      style={{ color: theme.color, backgroundColor: theme.primary }}
    >
      <div
        className="content"
        style={{ borderColor: theme.color, backgroundColor: theme.secondary }}
      >
        <Menu {...props} />
        <Banner {...props} />
        <Links {...props} />
        <div className="columns" style={{}}>
          <About {...props} />
          <FeaturedNFT {...props} />
        </div>
      </div>
      <Footer {...props} />
    </div>
  ) : null;
}

export default Home;
